/* Sam's Fragrances — back-in-stock "Notify me" + pre-order (replaces STOQ).
   Email sign-ups → Klaviyo profile + /apps/wishlist/notify (Worker waitlist). WhatsApp numbers → /apps/wishlist/notify (Worker),
   which saves them on a customer tagged notify-whatsapp and pings the owner. Pre-order = product tag "Pre-Order"
   (optional tag "ETA: 2 weeks"); button reads "Pre-order", a note is shown and the line gets a "Pre-order" property. */
(function () {
  'use strict';
  var KLAVIYO_KEY = 'TyUhdQ';
  var KLAVIYO_REV = '2025-01-15';
  var LS_KEY = 'sf_notify';
  var DOMAINS = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'icloud.com', 'live.com', 'msn.com', 'hotmail.fr', 'yahoo.fr'];

  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store() { try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function remember(v) { try { var s = store(); s[v] = Date.now(); localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch (e) {} }

  // ---- email typo suggestion (gmial.com → gmail.com)
  function lev(a, b) {
    var m = [], i, j;
    for (i = 0; i <= b.length; i++) m[i] = [i];
    for (j = 0; j <= a.length; j++) m[0][j] = j;
    for (i = 1; i <= b.length; i++) for (j = 1; j <= a.length; j++)
      m[i][j] = b[i - 1] === a[j - 1] ? m[i - 1][j - 1] : Math.min(m[i - 1][j - 1] + 1, m[i][j - 1] + 1, m[i - 1][j] + 1);
    return m[b.length][a.length];
  }
  function suggest(email) {
    var p = String(email || '').trim().toLowerCase().split('@');
    if (p.length !== 2 || !p[1]) return null;
    var d = p[1], best = null, bd = 3;
    for (var i = 0; i < DOMAINS.length; i++) {
      if (d === DOMAINS[i]) return null;
      var x = lev(d, DOMAINS[i]);
      if (x < bd) { bd = x; best = DOMAINS[i]; }
    }
    return best && bd <= 2 ? p[0] + '@' + best : null;
  }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function phoneOk(p) {
    var s = String(p || '').replace(/[^\d+]/g, '');
    return /^\+?\d{6,15}$/.test(s);
  }

  // ---- product page state
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  var product = null, preorder = false, eta = '';
  function currentVariantId() {
    var inp = $('product-form form[data-type="add-to-cart-form"] input[name="id"]') || $('form[action*="/cart/add"] input[name="id"]');
    var v = inp && inp.value;
    if (!v) v = new URLSearchParams(location.search).get('variant');
    return v ? String(v) : String(product && product.variants[0] && product.variants[0].id);
  }
  function variant() {
    var id = currentVariantId();
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === id) return product.variants[i];
    return product.variants[0];
  }

  // ---- notify button + modal
  var wrap, btn, modal, lastVid = null, lastAvail = null;
  function ensureButton() {
    var form = $('product-form');
    if (!form) return null;
    if (wrap && document.body.contains(wrap)) return wrap;
    wrap = el('div', { class: 'sf-notify', hidden: '' });
    btn = el('button', { type: 'button', class: 'sf-notify__btn button button--full-width' }, 'Notify me when it’s back');
    btn.addEventListener('click', openModal);
    wrap.appendChild(btn);
    var after = $('.product-form__buttons', form) || form;
    after.parentNode.insertBefore(wrap, after.nextSibling);
    return wrap;
  }

  function buildModal() {
    if (modal) return modal;
    modal = el('div', { class: 'sf-notify-modal', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'sf-notify-title', hidden: '' },
      '<div class="sf-notify-modal__backdrop" data-close></div>' +
      '<div class="sf-notify-modal__panel">' +
      '<button type="button" class="sf-notify-modal__x" data-close aria-label="Close"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
      '<div class="sf-notify-modal__body">' +
      '<h2 id="sf-notify-title" class="sf-notify-modal__title">Get notified</h2>' +
      '<p class="sf-notify-modal__product"></p>' +
      '<p class="sf-notify-modal__text">This one’s out of stock. Leave your email or WhatsApp number and we’ll tell you the moment it’s back.</p>' +
      '<form class="sf-notify-form" novalidate>' +
      '<label class="sf-notify-field"><span>Email</span><input type="email" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com"></label>' +
      '<p class="sf-notify-suggest" hidden></p>' +
      '<label class="sf-notify-field"><span>WhatsApp number <em>(optional)</em></span><input type="tel" name="phone" autocomplete="tel" inputmode="tel" placeholder="e.g. 70 123 456"></label>' +
      '<input type="text" name="company" class="sf-notify-hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
      '<p class="sf-notify-error" role="alert" hidden></p>' +
      '<button type="submit" class="sf-notify-submit button button--full-width">Notify me</button>' +
      '<p class="sf-notify-small">One message, only about this item.</p>' +
      '</form>' +
      '<div class="sf-notify-done" hidden>' +
      '<svg viewBox="0 0 24 24" width="40" height="40" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" stroke-width="1.3"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<p class="sf-notify-done__title">You’re on the list</p><p class="sf-notify-done__text"></p>' +
      '<button type="button" class="sf-notify-submit button button--full-width" data-close>Continue shopping</button>' +
      '</div></div></div>');
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    var f = $('.sf-notify-form', modal);
    var em = f.elements.email, sug = $('.sf-notify-suggest', modal);
    em.addEventListener('blur', function () {
      var s = suggest(em.value);
      if (s) { sug.innerHTML = 'Did you mean <button type="button" class="sf-notify-link">' + esc(s) + '</button>?'; sug.hidden = false; }
      else sug.hidden = true;
    });
    sug.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      em.value = b.textContent; sug.hidden = true; em.focus();
    });
    f.addEventListener('submit', submit);
    return modal;
  }

  var opener = null;
  function openModal() {
    buildModal();
    var v = variant();
    opener = document.activeElement;
    var name = product.title + (v && v.title && v.title !== 'Default Title' ? ' – ' + v.title : '');
    $('.sf-notify-modal__product', modal).textContent = name;
    var f = $('.sf-notify-form', modal), done = $('.sf-notify-done', modal), err = $('.sf-notify-error', modal);
    f.hidden = false; done.hidden = true; err.hidden = true;
    if (!f.elements.email.value && window.sfCustomerEmail) f.elements.email.value = window.sfCustomerEmail;
    if (store()[v.id]) { err.textContent = 'You’re already on the list for this item. Submit again to update your details.'; err.hidden = false; err.classList.add('is-info'); }
    else err.classList.remove('is-info');
    modal.hidden = false;
    document.documentElement.classList.add('sf-notify-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    setTimeout(function () { (f.elements.email.value ? f.elements.phone : f.elements.email).focus({ preventScroll: true }); }, 60);
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('sf-notify-open');
    setTimeout(function () { modal.hidden = true; }, 200);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  function klaviyoSubscribe(email, vid) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KLAVIYO_REV },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: {
        channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } })
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  function workerNotify(payload) {
    return fetch('/apps/wishlist/notify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function submit(e) {
    e.preventDefault();
    var f = e.target, err = $('.sf-notify-error', modal), sbtn = $('.sf-notify-submit', f);
    var email = f.elements.email.value.trim(), phone = f.elements.phone.value.trim();
    err.hidden = true; err.classList.remove('is-info');
    if (!email && !phone) { err.textContent = 'Please enter your email or WhatsApp number.'; err.hidden = false; return; }
    if (email && !EMAIL_RE.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; f.elements.email.focus(); return; }
    if (phone && !phoneOk(phone)) { err.textContent = 'Please enter a valid WhatsApp number.'; err.hidden = false; f.elements.phone.focus(); return; }
    var v = variant();
    sbtn.disabled = true; sbtn.classList.add('is-loading');
    var payload = { variantId: String(v.id), productTitle: product.title, variantTitle: v.title, handle: handle,
      email: email, phone: phone, hp: f.elements.company.value };
    var jobs = [];
    jobs.push(workerNotify(payload));
    Promise.allSettled(jobs).then(function (res) {
      sbtn.disabled = false; sbtn.classList.remove('is-loading');
      var kOk = true;
      var wRes = res[res.length - 1];
      var wOk = wRes.status === 'fulfilled';
      if (phone && !wOk) {
        var msg = wRes.reason && wRes.reason.error === 'phone' ? 'Please check your WhatsApp number (e.g. 70 123 456).' : 'Something went wrong. Please try again.';
        err.textContent = msg; err.hidden = false; return;
      }
      if (!wOk && !phone) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; return; }
      remember(v.id);
      var how = email && phone ? 'by email and WhatsApp' : email ? 'by email' : 'on WhatsApp';
      $('.sf-notify-done__text', modal).textContent = 'We’ll let you know ' + how + ' as soon as it’s back in stock.';
      f.hidden = true; $('.sf-notify-done', modal).hidden = false;
      try { if (window.gtag) gtag('event', 'notify_me_signup', { item_id: String(v.id), item_name: product.title, method: how }); } catch (x) {}
      try { if (window.fbq) fbq('trackCustom', 'NotifyMe', { content_ids: [String(v.id)], content_name: product.title }); } catch (x) {}
    });
  }

  // ---- pre-order
  var noteEl = null;
  function applyPreorder(v) {
    var form = $('product-form form[data-type="add-to-cart-form"]');
    if (!form) return;
    var prop = form.querySelector('input[name="properties[Pre-order]"]');
    var label = form.querySelector('[name="add"] > span');
    var on = preorder && v && v.available;
    if (on) {
      if (!prop) { prop = el('input', { type: 'hidden', name: 'properties[Pre-order]' }); form.appendChild(prop); }
      prop.value = eta ? 'Ships in ' + eta : 'Ships as soon as it arrives';
      if (label && label.textContent.trim() !== 'Pre-order') { label.dataset.sfOrig = label.textContent; label.textContent = 'Pre-order'; }
      if (!noteEl || !document.body.contains(noteEl)) {
        noteEl = el('p', { class: 'sf-preorder-note' });
        var after = $('.product-form__buttons', $('product-form')) || form;
        after.parentNode.insertBefore(noteEl, after);
      }
      noteEl.innerHTML = '<strong>Pre-order.</strong> ' + (eta ? 'Expected in ' + esc(eta) + '. ' : 'Ships as soon as it arrives. ') + 'Pay cash on delivery or via Whish as usual.';
      noteEl.hidden = false;
    } else {
      if (prop) prop.remove();
      if (label && label.dataset.sfOrig && label.textContent.trim() === 'Pre-order') { label.textContent = label.dataset.sfOrig; delete label.dataset.sfOrig; }
      if (noteEl) noteEl.hidden = true;
    }
  }

  function refresh() {
    if (!product) return;
    var v = variant();
    if (!v) return;
    var vid = String(v.id), avail = !!v.available;
    applyPreorder(v);
    if (vid === lastVid && avail === lastAvail && wrap && document.body.contains(wrap)) return;
    lastVid = vid; lastAvail = avail;
    var w = ensureButton();
    if (w) w.hidden = avail;
  }

  function initProduct() {
    if (!handle || !$('product-form')) return;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        var tags = (p.tags || []).map(function (t) { return String(t); });
        preorder = tags.some(function (t) { return /^pre-?order$/i.test(t.trim()); });
        tags.forEach(function (t) { var m = t.match(/^ETA\s*:\s*(.+)$/i); if (m) eta = m[1].trim(); });
        // test switch for QA without tagging a real product: ?sf_preorder_test=1[&sf_eta=2+weeks]
        var qs = new URLSearchParams(location.search);
        if (qs.get('sf_preorder_test') === '1') { preorder = true; if (qs.get('sf_eta')) eta = qs.get('sf_eta').slice(0, 40); }
        refresh();
        document.addEventListener('change', function () { setTimeout(refresh, 60); });
        typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(refresh, 60); }); setInterval(refresh, 3000);
      }).catch(function () {});
  }

  // ---- cart: note when a pre-order sits with in-stock items
  function cartNote() {
    var targets = document.querySelectorAll('#main-cart-footer .cart__blocks, cart-drawer .drawer__footer');
    if (!targets.length) return;
    (window.sfCart?window.sfCart():fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})).then(function (c) {
      var pre = 0, other = 0;
      (c.items || []).forEach(function (it) { if (it.properties && it.properties['Pre-order']) pre++; else other++; });
      targets.forEach(function (t) {
        var n = t.querySelector('.sf-preorder-cart');
        if (!pre) { if (n) n.remove(); return; }
        var msg = other ? 'Your cart has a pre-order item. We’ll deliver everything together once it arrives — message us on WhatsApp if you’d like the in-stock items sooner.'
          : 'Your cart has a pre-order item. We’ll deliver it as soon as it arrives.';
        if (!n) { n = el('p', { class: 'sf-preorder-cart' }); t.insertBefore(n, t.firstChild); }
        if (n.textContent !== msg) n.textContent = msg; // only touch the DOM on change (avoids observer loops)
      });
    }).catch(function () {});
  }
  var ct;
  function watchCart() {
    cartNote();
    var mo = new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(cartNote, 400); });
    var d = $('cart-drawer'); if (d) mo.observe(d, { childList: true, subtree: true });
    var m = $('#main-cart-footer'); if (m) mo.observe(m, { childList: true, subtree: true });
  }

  function start() { initProduct(); watchCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.sfNotify = { suggest: suggest, open: function () { if (product) openModal(); } };
})();
